<div class="empty-state" [ngClass]="size+'-panel'">
    <mat-icon [color]="iconColor" class="sif empty-state-icon mat-icon-no-color" [ngClass]="icon"></mat-icon>
    <h5 class="title">{{title}}</h5>
    <p *ngIf="message" class="message">{{message}}</p>
    <div *ngIf="subMessage" class="subMessage" [innerHTML]="subMessage"></div>
</div>